<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Time Slot</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="submitForm">
            <label>Start Time <span class="required">*</span></label>
            <input type="time" v-model="timeSlot.start_time" required>
            <div v-if="errors.start_time" class="error-message">{{ errors.start_time[0] }}</div>

            <label>End Time <span class="required">*</span></label>
            <input type="time" v-model="timeSlot.end_time" required>
            <div v-if="errors.end_time" class="error-message">{{ errors.end_time[0] }}</div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/time-slots')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timeSlot: { start_time: '', end_time: '' },
            isEditing: false,
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        convertTo24HourFormat(time) {
            if (!time) return '';
            const [formattedTime, modifier] = time.split(' ');
            let [hours, minutes] = formattedTime.split(':');
            if (modifier === 'PM' && hours !== '12') {
                hours = String(parseInt(hours) + 12);
            }
            if (modifier === 'AM' && hours === '12') {
                hours = '00';
            }
            return `${hours}:${minutes}`;
        },
        async submitForm() {
            this.errorMessage = null;
            this.errors = {};
            this.timeSlot.start_time = this.convertTo24HourFormat(this.timeSlot.start_time);
            this.timeSlot.end_time = this.convertTo24HourFormat(this.timeSlot.end_time);
            try {
                if (this.isEditing) {
                    await this.$api.put(`/time-slots/${this.$route.params.id}`, this.timeSlot);
                } else {
                    await this.$api.post('/time-slots', this.timeSlot);
                }
                this.$router.push('/dashboard/time-slots');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the time slot. Please try again later.';
                }
            }
        },
        async fetchTimeSlot() {
            if (this.$route.params.id) {
                this.isEditing = true;
                try {
                    const response = await this.$api.get(`/time-slots/${this.$route.params.id}`);
                    this.timeSlot = response.data;
                    console.log(this.timeSlot);
                } catch (error) {
                    this.errorMessage = 'Error fetching time slot data.';
                }
            }
        }
    },
    mounted() {
        this.fetchTimeSlot();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
